import React from "react";
import { Grid } from "@mui/material";

import SwitchComponent from "./SwitchComponent";

export default function SwitchDialog({ formikProps }) {
  return (
    <Grid item xs={12}>
      <SwitchComponent
        fieldDetails={formikProps.values}
        formikProps={formikProps}
        disabled={!formikProps.values.editable}
      />
    </Grid>
  );
}
